import InputAdornment from '@mui/material/InputAdornment';

import { CircularProgress } from '../../../CircularProgress';

import useStyles from './Preloader.style';

/**
 * Компонент для отображения индикатора загрузки в поле ввода.
 *
 * @public
 * @returns  Возвращает JSX-элемент представляющий компонент Preloader.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link Preloader}
 */
export const Preloader = () => {
  const { classes } = useStyles();

  return (
    <InputAdornment
      className={classes.preloader}
      position="end"
      sx={{ height: 0 }}
    >
      <CircularProgress size={18} />
    </InputAdornment>
  );
};
